(function () {
    const config = JSON.parse(
        document.querySelector('[data-shipping-protection-config]').innerHTML
    );
    const cartDrawer = document.getElementById('CartDrawer');

    if (!config || !config.productId || !cartDrawer) {
        return;
    }

    config.placeholderSelector = '[data-shipping-protection-placeholder]';

    function prepareProtectionVariant(cart) {
        let cartValue = cart.items_subtotal_price;
        const skusToSkip = config.skusToSkip.split(',').map(sku => sku.trim());
        cart.items.forEach(item => {
            if (skusToSkip.includes(item.sku) || config.productId === item.product_id) {
                cartValue -= item.line_price;
            }
        });

        return config.variants.find(
            variant => variant.cartMin <= cartValue && variant.cartMax > cartValue
        );
    }

    function renderOption(cart) {
        const placeholder = document.querySelector(config.placeholderSelector);
        if (!placeholder) {
            return;
        }

        if (
            !cart.item_count
            || (config.usOnly && document.documentElement.classList.contains('international-visitor'))
        ) {
            placeholder.innerHTML = '';

            return;
        }

        const protectionInCart = cart.items.find(item => item.product_id === config.productId);
        let protectionVariant;
        if (protectionInCart) {
            protectionVariant = config.variants.find(variant => variant.variantId === protectionInCart.variant_id);
        } else {
            protectionVariant = prepareProtectionVariant(cart);
        }

        if (protectionVariant) {
            const price = BryanAnthonys.formatMoney(protectionVariant.price);

            placeholder.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <shipping-protection class="shipping-protection flex justify-content-center pl-4 pr-4 pt-1 align-items-center">
                    <label class="custom-checkbox size-13">
                      <input type="checkbox" value="${protectionVariant.variantId}" ${protectionInCart ? 'checked' : ''}>
                      <span class="custom-checkbox__checkmark"></span>
                      <span class="custom-checkbox__text">${config.title.replace('[price]', price)}</span>
                    </label>
                    <shipping-protection-modal-opener>
                        <button 
                            type="button" aria-label="What is shipping protection?" aria-haspopup="dialog"
                            class="shipping-protection-modal-opener__button button-reset cursor-pointer"
                        >
                            <svg class="icon icon-error" aria-hidden="true" focusable="false">
                                <use href="#icon-error-black" />
                            </svg>
                        </button>
                    </shipping-protection-modal-opener>
                </shipping-protection>
            `));
        } else {
            placeholder.innerHTML = '';
        }
    }

    /**
     * When variant id is null or not defined, all shipping protection items will be removed from cart
     * @param variantId {int}
     * When the action runs automatically we do not want the customer to be redirected in case of an error
     * @param redirectOnError {boolean}
     */
    function updateCartProtection(variantId, redirectOnError = true) {
        BryanAnthonys.cart.fetch()
            .then(cart => {
                const updates = {};

                const protectionsInCart = cart.items.filter(item => item.product_id === config.productId);
                protectionsInCart.forEach(lineItem => {
                    updates[lineItem.key] = 0;
                });

                if (variantId) {
                    updates[variantId] = 1;
                }

                const body = {
                    updates,
                    sections: cartDrawer.getSectionsToRender().map(section => section.id).join(','),
                    sections_url: BryanAnthonys.pagePath()
                };
                BryanAnthonys.cart.update(JSON.stringify(body))
                    .then(cartDrawer.renderContents)
                    .catch(error => {
                        if (redirectOnError) {
                            BryanAnthonys.cart.handleError(
                                error,
                                body,
                                () => window.location.href = '/cart',
                                'cart_update'
                            );
                        }
                        console.error(error);
                    });
            });
    }

    function autoUpdateCartProtection(cart) {
        const protectionsInCart = cart.items.filter(item => item.product_id === config.productId);

        // There is no shipping protection in cart, no updates are needed
        if (!protectionsInCart.length) {
            return false;
        }

        const protectionVariant = prepareProtectionVariant(cart);

        // There is a single shipping protection item in cart, and it's the right one be for the current cart
        if (
            protectionsInCart.length === 1
            && protectionVariant
            && protectionVariant.variantId === protectionsInCart[0].variant_id
        ) {
            return false;
        }

        // Cart shipping protection needs to be updated because:
        //  - there are multiple shipping protection items in cart, and there must only be one
        //  - there is one shipping protection in cart but the tier variant id does not fit to the current cart
        //  - there is at least one shipping protection item in cart but there shouldn't be any - ex: cart gets emptied
        updateCartProtection(protectionVariant ? protectionVariant.variantId : null, false);

        return true;
    }

    customElements.define('shipping-protection', class extends HTMLElement {
        connectedCallback() {
            this.addEventListener('change', event => {
                event.stopPropagation();
                const checkbox = event.target;
                const variantId = checkbox.checked ? checkbox.value : null;
                checkbox.checked = !checkbox.checked;
                checkbox.classList.add('loading');
                checkbox.disabled = true;
                updateCartProtection(variantId);
            });
        }
    });

    customElements.define('shipping-protection-modal-opener', class extends HTMLElement {
        connectedCallback() {
            this.addEventListener('click', () => this.renderModal());
        }

        renderModal() {
            const cart = document.getElementById('CartDrawer');
            cart.querySelectorAll('shipping-protection-modal').forEach(modal => modal.remove());

            cart.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <shipping-protection-modal
                    id="ShippingProtectionModal" data-animated="true" data-animation-duration="400"
                    class="custom-modal custom-modal--centered custom-modal--animate-drop custom-modal--shipping-protection"
                    ${!cart.dataset.onCartPage ? 'data-unmovable="true" data-scope="CartDrawer"' : ''}
                    data-inherits-from-modal
                >
                    <div
                        class="custom-modal__content" role="dialog" tabindex="-1"
                        aria-label="Shipping protection details" style="--max-width: 45rem;" aria-modal="true" 
                    >
                        <div class="custom-modal__content-info center">
                            <button
                                id="ModalClose-ShippingProtectionModal" aria-label="Close modal" type="button"
                                class="custom-modal__toggle custom-modal__toggle--borderless custom-modal__toggle--corner custom-modal__toggle--small"
                            >
                                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                                    <use href="#icon-close"/>
                                </svg>
                            </button>
                            <img 
                                src="${config.productImage}" class="shiping-protection-modal__image mx-auto mb-3"
                                alt=${JSON.stringify(config.productTitle)} width="100" height="100" loading="lazy" 
                            />
                            <div class="uppercase letter-spacing-1 semi-heavy-weight mb-3">
                                ${config.productTitle}
                            </div>
                            <div class="mb-3 size-13">
                                ${config.subTitle}
                            </div>
                            <div class="size-13">
                                ${config.description}
                            </div>
                        </div>
                    </div>
                </shipping-protection-modal>
            `)));
            document.getElementById('ShippingProtectionModal').show(this);
        }
    });

    customElements.define('shipping-protection-modal', class extends ModalDialog {
        hide(forceClose = false) {
            super.hide(forceClose);

            this.opener.removeAttribute('data-open');
            if (!this.hasAttribute('open')) {
                setTimeout(() => this.remove(), 500);
            }
        }
    });

    BryanAnthonys.cart.addMutator('shipping-protection', autoUpdateCartProtection);
    renderOption(BryanAnthonys.cart.getCache());
    cartDrawer.addEventListener('cartRendered', () => renderOption(BryanAnthonys.cart.getCache()));
})();